import { render, staticRenderFns } from "./editSurvey.vue?vue&type=template&id=2503047a&scoped=true&"
import script from "./editSurvey.vue?vue&type=script&lang=js&"
export * from "./editSurvey.vue?vue&type=script&lang=js&"
import style0 from "./editSurvey.vue?vue&type=style&index=0&id=2503047a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503047a",
  null
  
)

export default component.exports